export default [
  {
    path: '/admin/trader/bots',
    name: 'Bots',
    component: () => import('@/views/Admin/Trader/Bots/Index.vue'),
    meta: {
      pageTitle: 'Bots',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Bots', active: true },
      ],
      resource: 'bots.list',
      action: 'read',
    },
  },
]
